import { createFileRoute } from '@tanstack/react-router';

import { ProjectsErrorScreen } from '../../features/projects/error-screen';
import { validateProjectDetailSearch } from '../../features/projects/facets';
import { ProjectDetail } from '../../features/projects/project-detail';
import { ProjectsToastProvider } from '../../features/projects/toast';

/**
 * `/projects/:id` (§6.3) — الشاشة التي تجيب «وين وصل مشروع X» بعرض حتمي محتسب من
 * البيانات، بلا أي نموذج لغوي في الويب. صارت حاويةً بأوجه (قرار المالك 2026-07-30)،
 * والوجه المفتوح يعيش في search params لا في حالة مكوّن.
 *
 * الاستيرادان منفصلان بحكم الميزانية لا الذوق: `validateSearch` خيار مسار يبقى في
 * الحزمة الابتدائية، والشاشة مكوّن يؤجّله `autoCodeSplitting` — انظر
 * `features/projects/facets.ts`.
 */
export const Route = createFileRoute('/projects/$projectId')({
  validateSearch: validateProjectDetailSearch,
  component: ProjectScreen,
  errorComponent: ProjectsErrorScreen,
});

function ProjectScreen() {
  const { projectId } = Route.useParams();
  const { facet } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ProjectsToastProvider>
      <ProjectDetail
        projectId={projectId}
        facet={facet}
        onFacetChange={(next) => void navigate({ search: { facet: next } })}
      />
    </ProjectsToastProvider>
  );
}
